var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1161,
    height: 1170,
    viewBox: "0 0 1161 1170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_183_2346)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 580.5,
    cy: 668.5,
    rx: 380.5,
    ry: 301.5,
    fill: "#1EBBE2",
    fillOpacity: 0.27
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_183_2346)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 733,
    cy: 343,
    rx: 153,
    ry: 143,
    fill: "#E2C51E",
    fillOpacity: 0.22
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_183_2346",
    x: 0,
    y: 167,
    width: 1161,
    height: 1003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_18300_2346"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_183_2346",
    x: 380,
    y: 0,
    width: 706,
    height: 686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_18300_2346"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundColor);
export default __webpack_public_path__ + "static/media/background_color.5a8cc16cd95fda68281b2bbdacf19c0c.svg";
export { ForwardRef as ReactComponent };